import React from "react";

export default function Logo({ className = "", size = "md" }) {
  const sizes = {
    sm: "text-xl",
    md: "text-2xl",
    lg: "text-4xl",
  };
  return (
    <div data-testid="mw-logo" className={`inline-flex items-center gap-2 font-heading font-bold ${sizes[size]} ${className}`}>
      <span className="inline-flex items-center justify-center w-9 h-9 rounded-2xl bg-watermelon text-white shadow-[0_3px_0_0_rgba(0,0,0,0.15)]">
        <span className="text-white text-lg">✦</span>
      </span>
      <span className="tracking-tight">
        <span className="text-ink">MathWhiz</span>
        <span className="text-watermelon"> Beads</span>
      </span>
    </div>
  );
}
